import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import EndPage from "./pages/endPage";
import Answer from "./pages/answer";
import Questionnaire from "./pages/questionnaire";
import QuestionPreview from "./pages/questionPreview";
import { ContextComponent } from "@/store";
import "./App.less";
import FastClick from "fastclick";

const str = navigator.userAgent.toLowerCase();
const ver = str.match(/cpu iphone os (.*?) like mac os/);

if (!ver) {
  //非IOS系统1
  // 引入fastclick 做相关处理
  FastClick.attach(document.body);
} else {
  if (parseInt(ver[1]) < 11) {
    // 引入fastclick 做相关处理
    FastClick.attach(document.body);
  }
}
function TestList() {
  return <div>未知页面</div>;
}
/////
function App() {
  return (
    <ContextComponent>
      <Router>
        <Switch>
          <Route path="/endPage" component={EndPage} />
          <Route path="/questionPreview" component={QuestionPreview} />
          <Route exact path="/91/:id" component={Questionnaire} />
          <Route exact path="/Questionnaire" component={Questionnaire} />
          <Route exact path="/Answer" component={Answer} />
          <Route path="/load/:id" component={Questionnaire} />
          <Route exact path="/*" component={TestList} />
        </Switch>
      </Router>
    </ContextComponent>
  );
}

export default App;
